const TOKEN_NAME = 'cj_website_auth_token';
const REFRESH_TOKEN_NAME = 'cj_website_refresh_token';

export {
    TOKEN_NAME,
    REFRESH_TOKEN_NAME,
};
